module.exports = __webpack_public_path__ + "static/media/image2.1c383f49.JPG";